module.exports = __webpack_public_path__ + "media/images/calendar-d47ae50c28d90a89f9e59415c1ff602d.svg";